import { render, staticRenderFns } from "./Navigations.vue?vue&type=template&id=0b635a42&scoped=true&"
import script from "./Navigations.vue?vue&type=script&lang=js&"
export * from "./Navigations.vue?vue&type=script&lang=js&"
import style0 from "./Navigations.vue?vue&type=style&index=0&id=0b635a42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b635a42",
  null
  
)

component.options.__file = "Navigations.vue"
export default component.exports